<template>
  <div>
    <div class="forbidden-modal-container">
      <div class="modal-content">
        <div class="title">账号已被封禁</div>
        <div class="desc">此账号涉及非法买卖账号等行为，违反了超级简历WonderCV<a href="/agreement" target="_blank">《用户协议》</a>。
          为了保护求职者个人信息及隐私安全，我们将此账号永久封禁。<br />
          -若您对封禁有异议，可点击【我要申诉】提交相关申诉材料，我们会协助您核实处理。<br />
          -若您从非官方渠道（如淘宝、闲鱼等）购买此账号，可点击【我要举证】，我们会协助您维护权益。</div>
        <div v-if="feedbackStatus !== 'reject'" class="footer">
          <div v-if="feedbackStatus !== 'pending'" class="footer-item" @click="handleClickBtn(1)">我要申诉</div>
          <div class="footer-item" @click="handleClickBtn(2)">我要举证</div>
        </div>
      </div>
    </div>
    <div v-if="codeState" class="qrcode-content" @click="codeState = false">
      <img src="https://logo.wondercv.com/banners/yTt84zErriR9J5l.png" alt="">
    </div>
  </div>
</template>

<script>
import { routerTo } from '@/assets/js/util'
export default {
  props: {
    feedbackStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      codeState: false
    }
  },
  mounted () { },
  components: {},
  watch: {},
  computed: {},
  methods: {
    handleClickBtn (type) {
      switch (type) {
        case 1:
          routerTo('/feedbacks/new?type=9', '_blank')
          break
        case 2:
          this.codeState = true;
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
.forbidden-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 7;
  background-color: rgba($color: #000000, $alpha: 0.5);

  .modal-content {
    width: 560px;
    border-radius: 8px;
    background-color: #fff;
    padding: 32px;

    .title {
      color: #404040;
      font-size: 18px;
      margin-bottom: 16px;
    }

    .desc {
      color: #606060;
      line-height: 18px;

      a {
        color: #ff6644;
        cursor: pointer;
      }
    }

    .footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 24px;

      .footer-item {
        display: flex;
        align-items: center;
        height: 32px;
        padding: 0 16px;
        border-radius: 4px;
        background-color: #ff6644;
        color: #fff;
        font-size: 14px;
        cursor: pointer;

        &:first-child {
          background-color: #fff;
          color: #ff6644;
          border: 1px solid #ff6644;
          margin-right: 8px;
        }
      }
    }
  }
}
.qrcode-content {
  @extend .forbidden-modal-container;
  z-index: 8;
  img {
    width: 200px;
    height: 200px;
  }
}
</style>